import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

const PublicationDate = ({ publishedAt }) => {
  if (!publishedAt) {
    return null;
  }

  return (
    <DateStyled>
      {__('Published on %{date}').i__({
        date: dayjs(publishedAt).format('LL'),
      })}
    </DateStyled>
  );
};

export default PublicationDate;

const DateStyled = styled(Box).attrs({
  font: 'body-regular-asphalt',
  display: 'block',
})``;
